import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { UserGroup } from "../../../domain/models/user-group.model";
import { map, merge, Observable, of as observableOf } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort"; 

export class UserGroupListDataSource extends DataSource<UserGroup> {
     paginator: MatPaginator | undefined;
          sort: MatSort | undefined;
          filter: Filter | undefined;
         constructor(public data :UserGroup[] ) {
            super();
          }
    
         connect(): Observable<UserGroup[]> {
           if (this.paginator && this.sort && this.data) {
             console.log(this.data);
             // Combine everything that affects the rendered data into one update
             // stream for the data-table to consume.
             return merge(observableOf(this.data), this.paginator.page, this.sort.sortChange)
               .pipe(map(() => {
                 return this.getPagedData(this.getSortedData([...this.data ]));
               }));
           } else {
             throw Error('Please set the paginator and sort on the data source before connecting.');
           }
         }


        private getPagedData(data: UserGroup[]): UserGroup[] {
            if (this.paginator) {
              const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
              return data.splice(startIndex, this.paginator.pageSize);
            } else {
              return data;
            }
          }

             private getSortedData(data: UserGroup[]): UserGroup[] {
                     if (!this.sort || !this.sort.active || this.sort.direction === '') {
                       return data;
                     }
                 
                     return data.sort((a, b) => {
                       const isAsc = this.sort?.direction === 'asc';
                       switch (this.sort?.active) { 
                         case 'groupName': return compare(+a.groupName, +b.groupName, isAsc); 
                         case 'createdAt': return compare(+a.createAt, +b.createAt, isAsc); 
                         case 'createdBy': return compare(+a.createdBy, +b.createdBy, isAsc); 
                         case 'members': return compare(+a.members, +b.members, isAsc); 
                         default: return 0;
                       }
                     });
                   }
            disconnect(): void {}
    

}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  export interface Filter {
    property: string,
    value: string
  }
  